import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import auth from '@/middleware/auth'

import layoutDefault from '@/layouts/default.vue'
import home from '@/views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: layoutDefault,
    children: [
      {
        path: '/',
        name: 'home',
        component: home,
        meta: {
          title: 'auto-reestr'
        }
      },
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
      },
      {
        path: 'map',
        name: 'map',
        component: () => import(/* webpackChunkName: "map" */ '@/views/Map.vue'),
        meta: {
          title: 'map'
        }
      },
      {
        path: 'dashboard',
        name: 'dasboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard.vue'),
        meta: {
          middleware: [
            auth.isAuthenticated
          ]
        },
        children: [
          {
            path: '/',
            component: () => import(/* webpackChunkName: "dashboard-index" */ '@/views/dashboard/index.vue'),
            meta: {
              title: 'dashboard'
            }
          },
          // {
          //   path: 'documents/medosmotr/create',
          //   component: () => import('../views/dashboard/documents/medosmotr/create.vue')
          // },
          {
            path: ':app',
            component: () => import(/* webpackChunkName: "dashboard-app" */ '@/views/dashboard/app.vue'),
            children: [
              {
                path: '/',
                component: () => import(/* webpackChunkName: "dashboard-app-index" */ '../views/dashboard/app/index.vue')
              },
              {
                path: ':model',
                component: () => import(/* webpackChunkName: "dashboard-app-model" */ '../views/dashboard/app/model.vue')
              },
              {
                path: ':model/create',
                name: 'create',
                component: () => import(/* webpackChunkName: "dashboard-app-create" */ '../views/dashboard/app/create.vue')
              },
              {
                path: ':model/:pk',
                name: 'view',
                component: () => import(/* webpackChunkName: "dashboard-app-view" */ '../views/dashboard/app/view.vue')
              }
            ]
          }
        ]
      },
      {
        path: 'me',
        component: () => import(/* webpackChunkName: "me" */ '../views/me.vue'),
        meta: {
          middleware: [
            auth.isAuthenticated
          ]
        }
      },
      {
        path: '*',
        component: () => import(/* webpackChunkName: "404" */ '../views/404page.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'is-active'
})

router.beforeEach((to, from, next) => {
  // ищет каждое совпадение во всех вышестоящих РОДИТЕЛЬСКИХ маршрутах
  if (to.matched.every(record => !record.meta.middleware)) {
    return next()
  }
  const middleware = to.matched.find(record => record.meta.middleware).meta.middleware
  const context = {
    to,
    from,
    next,
    store
  }
  return middleware[0]({
    ...context
  })
})

export default router
